<template>
  <div>
    <Menu />
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Profissionais PEC CNES"
            description="Validação de profissionais entre PEC e CNES"
            url="/dashboard"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <div class="form-group">
            <input
              type="text"
              class="form-control"
              placeholder="Nome do profissional"
              v-model="nome"
            />
          </div>
        </div>
        <div class="col-lg-12">
          <div class="info-table">
            <div class="info-table-item">
              <Subtitle
                @exibirVermelhos="handleExibirVermelhos"
                @exibirVerdes="handleExibirVerdes"
              ></Subtitle>
            </div>
            <div class="info-table-item">
              <p class="fonte">
                <b>Fonte:</b> e-SUS PEC, CNES, {{ ultimaAtualizacao }}
              </p>
            </div>
            <div class="info-table-item">
              <b>Total:</b> {{ total_de_registros_da_tabela }} pessoas
            </div>
            <div class="info-table-item">
              <download-files
                :callback-pdf="generatePdf"
                :data="displayedCadastros"
                :fields="dataFields"
                name="profissionais-pec-cnes"
              >
              </download-files>
            </div>
          </div>
        </div>
        <div class="col-md-12" v-if="visibleTable">
          <div class="box" style="margin-top: 0px">
            <table class="table table-responsive table-striped" id="table">
              <thead class="thead-light">
                <tr>
                  <th>CNES</th>
                  <th>INE</th>
                  <th>CPF</th>
                  <th>CNS</th>
                  <th>CBO</th>
                  <th>Função</th>
                  <th>Profissional</th>
                  <th>
                    Divergência
                    <span
                      v-b-tooltip.hover
                      title="CNES = Profissional cadastrado em outra Unidade de Saúde | INE = Profissional cadastrado em outra Equipe | CPF = Profissional com outro CPF no CNES | CNS = Profissional com outro CNS no CNES | CBO = Profissional com outro CBO no CNES"
                      class="icon-tooltip"
                    >
                      <i class="icofont-info-circle"></i>
                    </span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in displayedCadastros"
                  :key="index"
                  v-bind:class="printTableRow(item.divergencias)"
                >
                  <td>{{ item.nu_cnes }}</td>
                  <td>{{ item.nu_ine }}</td>
                  <td>{{ item.nu_cpf }}</td>
                  <td>{{ item.nu_cns }}</td>
                  <td>{{ item.co_cbo }}</td>
                  <td>{{ item.no_cbo }}</td>
                  <td>{{ item.no_profissional }}</td>
                  <td>{{ item.divergencias }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-12 mt-4" v-if="loading">
          <div class="loading-ellipse">
            <i class="icofont-warning-alt"></i> Aguarde. Carregando
            profissionais
          </div>
        </div>
        <div class="col-md-12" v-if="visibleTable">
          <pagination
            :page="page"
            :pages="pages"
            v-on:update:page="page = $event"
          >
          </pagination>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '../../components/Menu'
import Footer from '../../components/Footer'
import { mapState } from 'vuex'
import SectionTitle from '../../components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import Subtitle from './Subtitle'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import Pagination from '@/components/utils/Pagination'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import * as Functions from './functions'
import DownloadFiles from '@/components/utils/DownloadFiles.vue'
export default {
  name: 'ProfissionaisPecCnes',
  metaInfo: {
    title: 'eSUS Feedback - Profissionais PEC CNES',
    titleTemplate: null,
  },
  mixins: [utils],
  components: {
    Menu,
    Footer,
    PulseLoader,
    SectionTitle,
    Subtitle,
    Pagination,
    DownloadFiles,
  },

  data() {
    return {
      id_funcao: '',
      cod_ibge: '',
      user_id: '',
      equipes: [],
      equipe: '',
      cadastros: [],
      cadastrosPdf: [],
      array_divergencias: [],
      page: 1,
      perPage: 10,
      pages: [],
      nome: '',
      cns: '',
      total_de_registros_da_tabela: 0,
      loading: false,
      size: '40px',
      color: '#0D98BB',
      visibleTable: false,
      exibirCadastrosVermelhos: false,
      exibirCadastrosVerdes: false,
      dataFields: {
        ...Functions.dataFields,
      },
    }
  },
  computed: {
    displayedCadastros() {
      if (
        this.nome == '' &&
        this.exibirCadastrosVermelhos == false &&
        this.exibirCadastrosVerdes == false
      ) {
        this.setPages(this.cadastros)
        this.total_de_registros_da_tabela = this.cadastros.length
        this.cadastrosPdf = this.cadastros
        return this.paginate(this.cadastros)
      }

      // busca pelo nome
      if (this.nome != '') {
        let filtro2 = this.cadastros.filter((item) => {
          if (
            item.no_profissional
              .toUpperCase()
              .toUpperCase()
              .indexOf(this.nome.toUpperCase()) > -1
          ) {
            return true
          }
          return false
        })
        this.setPages(filtro2)
        this.total_de_registros_da_tabela = filtro2.length
        if (filtro2.length < 10) {
          this.page = 1
        }
        this.cadastrosPdf = filtro2
        return this.paginate(filtro2)
      }

      // mostra os vermelhos
      if (this.exibirCadastrosVermelhos == true) {
        let filtro3 = this.exibirVermelhos(this.cadastros)
        this.setPages(filtro3)
        this.total_de_registros_da_tabela = filtro3.length
        this.cadastrosPdf = filtro3
        return this.paginate(filtro3)
      }

      // mostra os verdes
      if (this.exibirCadastrosVerdes == true) {
        let filtro4 = this.exibirVerdes(this.cadastros)
        this.setPages(filtro4)
        this.cadastrosPdf = filtro4
        this.total_de_registros_da_tabela = filtro4.length
        return this.paginate(filtro4)
      }
    },
    ...mapState(['user']),
    ultimaAtualizacao() {
      return this.$store.getters['getUltimaAtualizacao']
    },
  },
  methods: {
    handleExibirVermelhos(event) {
      if (event == true) {
        this.exibirCadastrosVermelhos = true
        this.exibirCadastrosVerdes = false
      } else {
        this.exibirCadastrosVermelhos = false
      }
    },

    handleExibirVerdes(event) {
      if (event == true) {
        this.exibirCadastrosVerdes = true
        this.exibirCadastrosVermelhos = false
      } else {
        this.exibirCadastrosVerdes = false
      }
    },

    setPages(cadastros) {
      let numberOfPages = Math.ceil(cadastros.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },

    paginate(cadastros) {
      let page = this.page
      let perPage = this.perPage
      let from = page * perPage - perPage
      let to = page * perPage
      return cadastros.slice(from, to)
    },

    async carregarEquipes() {
      try {
        let response = await this.$api.get('/app/equipes/' + this.cod_ibge)
        if (response) {
          this.equipes = response.data
        }
      } catch (error) {
        console.log(error)
      }
    },

    buscarProfissionaisPec() {
      this.$api
        .get('/app/profissionais-pec-cnes/' + this.cod_ibge)
        .then((response) => {
          // this.cadastros = response.data;
          this.verificarDivergencias(response.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    async verificarDivergencias(cadastros) {
      let profissionais_pec_cnes = []
      this.loading = true
      for (let i = 0; i < cadastros.length; i++) {
        try {
          let response = await this.$api.get(
            '/app/profissional-pec-cnes-datasus/' + cadastros[i].nu_cpf
          )
          if (response.data.ProfissionalSaude) {
            let objProfissional = {
              nu_cpf: '',
              cbo: false,
              cnes: false,
              cns: false,
              cpf: false,
              nome: false,
            }

            objProfissional.nu_cpf = cadastros[i].nu_cpf

            if (response.data.ProfissionalSaude.CBO.length > 1) {
              for (
                let j = 0;
                j < response.data.ProfissionalSaude.CBO.length;
                j++
              ) {
                if (
                  response.data.ProfissionalSaude.CBO[j].codigoCBO !=
                    undefined &&
                  response.data.ProfissionalSaude.CBO[j].codigoCBO ==
                    cadastros[i].co_cbo
                ) {
                  objProfissional.cbo = false
                  break
                } else {
                  objProfissional.cbo = true
                }
              }
            } else {
              if (
                response.data.ProfissionalSaude.CBO.codigoCBO != undefined &&
                response.data.ProfissionalSaude.CBO.codigoCBO !=
                  cadastros[i].co_cbo
              ) {
                objProfissional.cbo = true
              }
            }

            if (response.data.ProfissionalSaude.CNES.length > 1) {
              for (
                let j = 0;
                j < response.data.ProfissionalSaude.CNES.length;
                j++
              ) {
                if (
                  response.data.ProfissionalSaude.CNES[j].CodigoCNES.codigo !=
                    undefined &&
                  response.data.ProfissionalSaude.CNES[j].CodigoCNES.codigo ==
                    cadastros[i].nu_cnes
                ) {
                  objProfissional.cnes = false
                  break
                } else {
                  objProfissional.cnes = true
                }
              }
            } else {
              if (
                response.data.ProfissionalSaude.CNES.CodigoCNES.codigo !=
                  undefined &&
                response.data.ProfissionalSaude.CNES.CodigoCNES.codigo !=
                  cadastros[i].nu_cnes
              ) {
                objProfissional.cnes = true
              }
            }

            if (
              response.data.ProfissionalSaude.CPF.numeroCPF != undefined &&
              response.data.ProfissionalSaude.CPF.numeroCPF !=
                cadastros[i].nu_cpf
            ) {
              objProfissional.cpf = true
            }

            if (response.data.ProfissionalSaude.CNS.length > 1) {
              for (
                let j = 0;
                j < response.data.ProfissionalSaude.CNS.length;
                j++
              ) {
                if (
                  response.data.ProfissionalSaude.CNS[j].numeroCNS !=
                    undefined &&
                  response.data.ProfissionalSaude.CNS[j].numeroCNS ==
                    cadastros[i].nu_cns
                ) {
                  objProfissional.cns = false
                  break
                } else {
                  objProfissional.cns = true
                }
              }
            } else {
              if (
                response.data.ProfissionalSaude.CNS.numeroCNS != undefined &&
                response.data.ProfissionalSaude.CNS.numeroCNS !=
                  cadastros[i].nu_cns
              ) {
                objProfissional.cns = true
              }
            }

            if (
              response.data.ProfissionalSaude.Nome.Nome.toUpperCase() !=
                undefined &&
              response.data.ProfissionalSaude.Nome.Nome.toUpperCase() !=
                cadastros[i].no_profissional.toUpperCase()
            ) {
              objProfissional.nome = true
            }

            // let divergencias = this.retornarDivergencias(objProfissional);
            let divergencias = ''
            if (objProfissional.cbo == true) {
              divergencias += 'CBO '
            } else if (objProfissional.cnes == true) {
              divergencias += 'CNES '
            } else if (objProfissional.cns == true) {
              divergencias += 'CNS '
            } else if (objProfissional.cpf == true) {
              divergencias += 'CPF '
            } else if (objProfissional.nome == true) {
              divergencias += 'NOME '
            } else {
              divergencias = 'OK'
            }

            // salva as divergencias do usuário na tabela usuarios
            try {
              let response2 = await this.$api.post(
                '/app/usuario/divergencias-pec-cnes',
                {
                  cpf: response.data.ProfissionalSaude.CPF.numeroCPF,
                  divergencia_pec_cnes: divergencias,
                  cod_ibge: this.cod_ibge,
                }
              )
            } catch (error) {
              console.log(error)
            }

            cadastros[i]['divergencias'] = divergencias
          }
        } catch (error) {
          console.log(error)
        }
      }
      this.cadastros = cadastros
      this.visibleTable = true
      this.loading = false
    },

    async onChangeEquipe(event) {
      this.loading = true
      this.equipe = event.target.value
      this.$api
        .get('/app/profissionais-pec-cnes/' + this.equipe)
        .then((response) => {
          this.cadastros = response.data.ProfissionalSaude
          this.loading = false
        })
        .catch(function (error) {
          console.log(error)
        })
    },

    // retorna as divergencias de acordo com o profissional
    retornarDivergencias(objetoProfissional) {
      this.loading = true
      let response = ''
      if (objetoProfissional != undefined) {
        if (objetoProfissional.cbo == true) {
          response += 'CBO '
        } else if (objetoProfissional.cnes == true) {
          response += 'CNES '
        } else if (objetoProfissional.cns == true) {
          response += 'CNS '
        } else if (objetoProfissional.cpf == true) {
          response += 'CPF '
        } else if (objetoProfissional.nome == true) {
          response += 'NOME '
        } else {
          response = 'OK'
        }
      }
      return response
    },

    // Muda a cor dos textos de cada linha da tabela
    printTableRow(divergencias) {
      if (divergencias != undefined) {
        if (divergencias != 'OK') {
          return 'red'
        } else {
          return 'green'
        }
      } else {
        return 'red'
      }
    },

    exibirVermelhos(cadastros) {
      let filtro = cadastros.filter((item) => {
        if (item.divergencias != undefined) {
          if (item.divergencias != 'OK') {
            return true
          } else {
            return false
          }
        } else {
          return true
        }
      })
      return filtro
    },

    exibirVerdes(cadastros) {
      let filtro = cadastros.filter((item) => {
        if (item.divergencias != undefined) {
          if (item.divergencias != 'OK') {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      })
      return filtro
    },

    generatePdf() {
      let title_pdf = this.$store.getters.getCidade
      let titlePdfSave = this.titlePdf(
        'Profissionais PEC CNES',
        this.$store.getters.getCidade
      )
      let description_pdf =
        'Profissionais com cadastros divergentes entre PEC e CNES'
      let description_pdf_2 =
        '* Para evitar reprovação de produção no SISAB, torna-se importante resolver, principalmente, as lotações de Médicos, Enfermeiros, Odontólogos, ACS, Recepcionistas, Técnicos ou Auxiliares de Enfermagem ou Saúde Bucal e outros profissionais que informam produção no e-SUS PEC ou CDS.'
      let description_pdf_3 =
        'Quando o profissional não atuar mais no serviço é importante sempre inativar as lotações dele.'
      let headers_pdf = [
        'CNES',
        'INE',
        'CPF',
        'CNS',
        'CBO',
        'FUNÇÃO',
        'PROFISSIONAL',
        'DIVERGÊNCIA',
      ]
      var data_pdf = []
      for (let i = 0; i < this.cadastrosPdf.length; i++) {
        var obj = {}
        obj.nu_cnes = this.cadastrosPdf[i].nu_cnes
        obj.nu_ine = this.cadastrosPdf[i].nu_ine
        obj.nu_cpf = this.cadastrosPdf[i].nu_cpf
        obj.nu_cns = this.cadastrosPdf[i].nu_cns
        obj.co_cbo = this.cadastrosPdf[i].co_cbo
        obj.no_cbo = this.cadastrosPdf[i].no_cbo
        obj.no_profissional = this.cadastrosPdf[i].no_profissional
        obj.divergencias = this.cadastrosPdf[i].divergencias
        data_pdf.push(obj)
      }
      let doc = new jsPDF()
      let rows = []
      for (let i = 0; i < data_pdf.length; i++) {
        rows[i] = Object.values(data_pdf[i])
      }
      let table = []
      for (var i = 0; i < rows.length; i++) {
        var tableRow = rows[i]
        for (var i = 0; i < rows.length; i++) {
          var tableRow = rows[i]
          var rowData = []
          if (tableRow.length != 0) {
            for (var j = 0; j < tableRow.length; j++) {
              rowData.push(tableRow[j])
            }
          } else {
            continue
          }
          table.push(rowData)
        }
      }
      doc.setFontSize(18)
      doc.text(title_pdf, 105, 20, null, null, 'center')
      doc.setFontSize(14)
      doc.text(description_pdf, 105, 27, null, null, 'center')
      doc.setFontSize(10)
      var splitTitle = doc.splitTextToSize(description_pdf_2, 180)
      doc.text(splitTitle, 15, 34)
      var splitTitle2 = doc.splitTextToSize(description_pdf_3, 180)
      doc.text(splitTitle2, 15, 50)
      doc.text('Município: ' + store.state.cidade, 15, 60, null, null, 'left')
      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: 62,
        showHead: 'firstPage',
        // pinta a cor de cada linha da tabela
        willDrawCell: function (data) {
          let divergencias = data.row.raw[7]
          if (divergencias == 'OK') {
            doc.setTextColor(2, 99, 57)
          } else {
            doc.setTextColor(194, 10, 16)
          }
          // pinta a cor da descrição das colunas de preto
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })
      doc.save(titlePdfSave + '.pdf')
      let now = new Date()
      let name_file = `CADASTROS DIVERGENTES ENTRE PEC E CNES, ${
        this.$store.getters.getCidade
      }, ${now.getDate()}-${now.getMonth()}-${now.getFullYear()}`
      doc.save(name_file + '.pdf')

      this.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    },

    init() {
      this.id_funcao = this.$store.state.id_funcao
      this.user_id = this.$store.state.id
      this.cod_ibge = this.$store.state.cod_ibge
      this.buscarProfissionaisPec()
    },
  },
  created() {
    this.init()
  },
}
</script>

<style>
.green {
  color: forestgreen;
}

.red {
  color: red;
}

.loading-ellipse {
  font-size: 20px;
  padding: 15px;
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

.loading-ellipse:after {
  overflow: hidden;
  display: inline-block;
  vertical-align: bottom;
  -webkit-animation: ellipsis steps(4, end) 900ms infinite;
  animation: ellipsis steps(4, end) 900ms infinite;
  content: '\2026'; /* ascii code for the ellipsis character */
  width: 0px;
  font-size: 20px;
}

@keyframes ellipsis {
  to {
    width: 1.25em;
  }
}

@-webkit-keyframes ellipsis {
  to {
    width: 1.25em;
  }
}
</style>
